export const experienceData = [
    {
        id: 1,
        company: 'Hexcode Infotech',
        jobtitle: 'PHP Laravel Developer',
        startYear: 'May 2023',
        endYear: 'May 2024'
    },
    {
        id: 2,
        company: 'Mid-sized Tech Company',
        jobtitle: 'Full Stack Developer',
        startYear: 'June 2024',
        endYear: 'October 2025'
    },
    {
        id: 3,
        company: 'Code and build something everyday',
        jobtitle: 'Self Employed',
        startYear: '2023',
        endYear: 'Present'
    },
]